import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function ZoneTypeSkeleron({ langLocal }) {
    return (
        <>
            {[1, 2,].map((index) => {
                return (
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }} >
                        <div style={{ width: "23%", height: '35px' }}>
                            <Skeleton width='100%' height='100%' borderRadius={5} />
                        </div>
                        <div style={{
                            width: "23%", height: '35px',
                            margin: `${langLocal === 'ar' ? "0px 10px 0px 0px" : "0px 0px 0px 10px"}`
                        }} >
                            <Skeleton width='100%' height='100%' borderRadius={5} />
                        </div>
                        <div style={{
                            width: "3%", height: '35px',
                            margin: `${langLocal === 'ar' ? "0px 10px 0px 0px" : "0px 0px 0px 10px"}`
                        }}>
                            <Skeleton width='100%' height='100%' borderRadius={5} />
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default ZoneTypeSkeleron